import ErrorTooltip from 'Components/ErrorTooltip';
import env from 'environment_system/env_system';
import { Field, FieldArray, FieldProps, useFormikContext } from 'formik';
import { checkValidArray, safeParse, saveEditForm } from 'GenericForms/Helper';
import React, { useEffect } from 'react'
import { Button, CardBody, CardFooter, Col, Form, Input, Row } from 'reactstrap';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import LOAdjustmentPopUp from './LOAdjustmentPopUp';
import Message from 'Components/Message';
import LubeOilROBDetailsTable from './LubeOilROBDetailsTable';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
interface LubeOilROBProps {
    VesselLubeOils: any;
    setEditValues?: any;
    editValues?: any;
    LubeOilFormik: any;
    refreshKey: number;
    setErrorMessage: any;
    setRefreshKey: any;
    handleSave: any;
    setAdjustmentPopup: any;
    adjustmentpopup: any;
    index?: number;
    setIndex?: (index: number) => void;
    editInitialValues?: any;
    editSubmit?: any;
    editIsSubmitting?: any,
    toggleDynamicTabs?: any
}

const LubeOilROBStructure = ({
    VesselLubeOils,
    setEditValues,
    editValues,
    LubeOilFormik,
    setErrorMessage,
    handleSave,
    setAdjustmentPopup,
    adjustmentpopup,
    index,
    setIndex,
    editSubmit,
    editIsSubmitting,
    toggleDynamicTabs,
}: LubeOilROBProps) => {
    /** State variables */
    const { editReportBool, setPreviousTabIndex, previousEnggTabIndex, discardwarning } = useEditReport();
    const { CurrentReport, PreviousReport } = useSelector((state: RootState) => state.Reporting);
    const lubeOilConsumptionCurrentReport = CurrentReport?.data?.chief_engineer?.lube_oil_consumption ?? null;
    const lubeOilROBpreviousReport = PreviousReport?.data?.chief_engineer?.reporting_lube_oil_rob ?? null;
    const { values, errors, touched, handleChange, handleBlur, isSubmitting, resetForm, setErrors, handleSubmit, setFieldValue, validateForm, setFieldTouched }:
        { values: any, errors: any, touched: any, handleChange: any, handleBlur: any, isSubmitting: any, resetForm: any, setErrors: any, handleSubmit: any, setFieldValue: any, validateForm: any, setFieldTouched: any } = useFormikContext<any>();
    /** State variables end */

    /** useEffect */
    useEffect(() => {
        if (checkValidArray(editValues?.chief_engineer?.lube_oil_consumption)) {
            setEditValues({
                ...editValues,
                chief_engineer: {
                    ...editValues?.chief_engineer,
                    lube_oil_consumption: values.lubeOil
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.lubeOil])
    /** useEffect end */
    return (
        <Form className="needs-validation" autoComplete="off" onSubmit={handleSubmit}>
            <CardBody className='px-2 py-0'>
                <Row>
                    <Col sm="12">
                        {VesselLubeOils &&
                            <div className="table-responsive p-0">
                                <table className="table mb-2">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="p-2 sr-no-width">#</th>
                                            <th className="text-left align-middle p-2" style={{ width: '40%' }}>Lube oil</th>
                                            <th className="text-center align-middle p-2" style={{ width: '30%' }}>Lube oil consumption</th>
                                            <th className="text-center align-middle p-2" style={{ width: '30%' }}>Adjustment</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <FieldArray name='lubeOil'>
                                            {() => (
                                                <>
                                                    {values && values?.lubeOil?.length > 0 ? (
                                                        values?.lubeOil?.map((lubeOil: any, index: number) => {
                                                            return (
                                                                <React.Fragment key={lubeOil.id}>
                                                                    <tr>
                                                                        <td className='p-2 text-center'>{index + 1}</td>
                                                                        <td className="p-2 align-middle">
                                                                            <LubeOilROBDetailsTable
                                                                                lubeOilName={lubeOil.lube_name}
                                                                                previousROB={parseFloat(lubeOil?.previous_rob) || 0}
                                                                                bunkered={parseFloat(values?.lubeOil[index]?.bunkered) || 0}
                                                                                debunkered={parseFloat(values?.lubeOil[index]?.debunkered) || 0}
                                                                                consumed={parseFloat(values?.lubeOil[index]?.consumed) || 0}
                                                                                adjustment={parseFloat(values?.lubeOil[index]?.adjustment_quantity) || 0}
                                                                                currentROB={parseFloat(values?.lubeOil[index]?.rob) || 0}
                                                                            />
                                                                        </td>
                                                                        <td className="p-2 text-center align-middle">
                                                                            <div className="input-group justify-content-center align-items-center">
                                                                                <Field name={`lubeOil.${index}.consumed`}>
                                                                                    {() => (
                                                                                        <Input
                                                                                            onFocus={(e) => e.target.select()}
                                                                                            type="text"
                                                                                            autoFocus={index === 0 ? true : false}
                                                                                            className="form-control max-width-7 text-right align-middle"
                                                                                            id={`consumed-${index}`}
                                                                                            name={`lubeOil.${index}.consumed`}
                                                                                            defaultValue={values?.lubeOil[index]?.consumed}
                                                                                            onBlur={(e: any) => {
                                                                                                handleBlur(e);
                                                                                                const loConsumption = safeParse(e.target.value) || 0;
                                                                                                const quantityBunkered = safeParse(values?.lubeOil[index]?.bunkered) || 0;
                                                                                                const quantityDebunkered = safeParse(values?.lubeOil[index]?.debunkered) || 0;
                                                                                                const previousROB = safeParse(values?.lubeOil[index]?.previous_rob) || 0;
                                                                                                const QuantityAdjusted = safeParse(values?.lubeOil[index]?.adjustment_quantity) || 0;
                                                                                                let newLROB = 0;
                                                                                                if (checkValidArray(lubeOilConsumptionCurrentReport)) {
                                                                                                    newLROB = previousROB + quantityBunkered - loConsumption - quantityDebunkered + QuantityAdjusted;
                                                                                                } else {
                                                                                                    const matchedPrevious = lubeOilROBpreviousReport && lubeOilROBpreviousReport?.find(
                                                                                                        (item: any) => item?.vessel_lube_oil === lubeOil?.vessel_lube_oil
                                                                                                    );
                                                                                                    const fallbackPreviousROB = safeParse(matchedPrevious?.rob);
                                                                                                    newLROB = fallbackPreviousROB - loConsumption - quantityDebunkered;
                                                                                                }
                                                                                                setFieldValue(`lubeOil.${index}.rob`, newLROB);
                                                                                            }}
                                                                                            onChange={(e: any) => {
                                                                                                handleChange(e);
                                                                                                const loConsumption = safeParse(e.target.value) || 0;
                                                                                                const quantityBunkered = safeParse(values?.lubeOil[index]?.bunkered) || 0;
                                                                                                const quantityDebunkered = safeParse(values?.lubeOil[index]?.debunkered) || 0;
                                                                                                const previousROB = safeParse(values?.lubeOil[index]?.previous_rob) || 0;
                                                                                                const QuantityAdjusted = safeParse(values?.lubeOil[index]?.adjustment_quantity) || 0;
                                                                                                let newLROB = 0;
                                                                                                if (lubeOilConsumptionCurrentReport) {
                                                                                                    newLROB = previousROB + quantityBunkered - loConsumption - quantityDebunkered + QuantityAdjusted;
                                                                                                } else {
                                                                                                    const matchedPrevious = lubeOilROBpreviousReport.find(
                                                                                                        (item: any) => item?.lube_oil_name === lubeOil?.lube_oil_name
                                                                                                    );
                                                                                                    const fallbackPreviousROB = safeParse(matchedPrevious?.rob);
                                                                                                    newLROB = fallbackPreviousROB - loConsumption - quantityDebunkered;
                                                                                                }
                                                                                                setFieldValue(`lubeOil.${index}.rob`, newLROB);
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                                <div className="input-group-text align-middle">ltr</div>
                                                                            </div>

                                                                            {errors?.lubeOil && touched?.lubeOil && touched?.lubeOil[index]?.consumed &&
                                                                                errors?.lubeOil[index]?.consumed && env?.form_validation === true && !adjustmentpopup && !discardwarning &&
                                                                                <ErrorTooltip
                                                                                    target={`consumed-${index}`}
                                                                                    message={errors?.lubeOil[index]?.consumed}
                                                                                    open={!!errors?.lubeOil[index]?.consumed}
                                                                                />
                                                                            }
                                                                            {errors?.lubeOil && touched?.lubeOil &&
                                                                                errors?.lubeOil[index]?.rob && env?.form_validation === true && !adjustmentpopup &&
                                                                                <ErrorTooltip
                                                                                    target={`consumed-${index}`}
                                                                                    message={errors?.lubeOil[index]?.rob}
                                                                                    open={!!errors?.lubeOil[index]?.rob}
                                                                                />
                                                                            }
                                                                        </td>

                                                                        <td className="p-2 text-center align-middle">
                                                                            <div className="input-group justify-content-center align-items-center">
                                                                                <Field name={`lubeOil.${index}.adjustment_quantity`}>
                                                                                    {({ field }: FieldProps) => (
                                                                                        <Input
                                                                                            onFocus={(e) => e.target.select()}
                                                                                            type="text"
                                                                                            className="form-control max-width-7 text-right align-middle"
                                                                                            id={`lrob_${index}`}
                                                                                            name={field.name}
                                                                                            onClick={(e) => {
                                                                                                handleBlur(e);
                                                                                                setAdjustmentPopup(true);
                                                                                                setIndex(index);
                                                                                            }}
                                                                                            onKeyUp={(e: any) => {
                                                                                                handleBlur(e);
                                                                                                setAdjustmentPopup(true);
                                                                                                setIndex(index);
                                                                                            }}
                                                                                            onBlur={(e: any) => handleChange(e)}
                                                                                            value={values?.lubeOil[index]?.adjustment_quantity ?? 0}
                                                                                            tabIndex={-1}
                                                                                        />
                                                                                    )}
                                                                                </Field>
                                                                                <div className="input-group-text align-middle">ltr</div>
                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={5} className="p-4 text-center">
                                                                <Message message='No Lube Oil configured' type='danger' />
                                                            </td>
                                                        </tr>
                                                    )}
                                                </>
                                            )}
                                        </FieldArray>
                                    </tbody>
                                </table>
                            </div>
                        }
                    </Col>
                </Row>
            </CardBody>
            <CardFooter className="p-2 py-3">
                <Row className="d-flex align-items-center flex-row-reverse">
                    <Col lg={10}>
                        <div className="d-flex flex-wrap gap-3 justify_right">
                            {/* {editReportBool &&
                                <Button
                                    type="reset"
                                    color="danger"
                                    className="btn_size_cstm"
                                    onClick={() => {
                                        setEditValues({
                                            ...editValues,
                                            chief_engineer: {
                                                ...editValues?.chief_engineer,
                                                lube_oil_consumption: editInitialValues?.chief_engineer?.lube_oil_consumption,
                                            }
                                        })
                                        setRefreshKey(refreshKey + 1);
                                    }}
                                >
                                    Reset
                                </Button>
                            } */}
                            <Button
                                type={editReportBool ? "button" : "submit"}
                                color="primary"
                                className="btn_size_cstm"
                                disabled={isSubmitting || editIsSubmitting}
                                onClick={async () => {
                                    // Run validation and get current errors
                                    const validationErrors = await validateForm();

                                    // Touch all lubeOil fields
                                    (values.lubeOil || []).forEach((item: any, index: number) => {
                                        Object.keys(item).forEach((field) => {
                                            setFieldTouched(`lubeOil[${index}].${field}`, true, false);
                                        });
                                    });

                                    // Only proceed if valid
                                    if (editReportBool && Object.keys(validationErrors).length === 0) {
                                        await saveEditForm(editSubmit, toggleDynamicTabs, previousEnggTabIndex, setPreviousTabIndex);
                                    }
                                }}
                            >
                                {(isSubmitting || editIsSubmitting) && (
                                    <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                )}
                                Next <i className="bx bx-chevron-right ms-1" />
                            </Button>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <Button
                            type="button"  // Change from "submit" to "button"
                            color="primary"
                            className="btn_size_cstm"
                            onClick={() => {
                                setErrorMessage(null);
                                setErrors({});
                                resetForm();
                                toggleDynamicTabs(previousEnggTabIndex - 1);
                            }}
                        >
                            <i className="bx bx-chevron-left me-1" /> Previous
                        </Button>
                    </Col>
                </Row>
            </CardFooter>
            {adjustmentpopup &&
                <LOAdjustmentPopUp
                    state={adjustmentpopup}
                    setState={setAdjustmentPopup}
                    tog_backdrop={() => setAdjustmentPopup(false)}
                    target="lubeOil"
                    index={index}
                    handleSave={handleSave}
                />
            }
            <FormValuesDebug values={[values, errors, LubeOilFormik.initialValues]} />
        </Form>
    )
}

export default LubeOilROBStructure
